export const PLAN_DATA_RECEIVED = 'PLAN_DATA_RECEIVED'
export const PLAN_DATA_UNLOAD = 'PLAN_DATA_UNLOAD'
